import { PRIORITY_CONFIG } from '@/constants';

import type { TaskDetail } from '@/types';

export function getPriorityInfo(priority: number) {
  if (priority >= PRIORITY_CONFIG.CRITICAL.min && priority <= PRIORITY_CONFIG.CRITICAL.max) {
    return PRIORITY_CONFIG.CRITICAL;
  }
  if (priority >= PRIORITY_CONFIG.HIGH.min && priority <= PRIORITY_CONFIG.HIGH.max) {
    return PRIORITY_CONFIG.HIGH;
  }
  return PRIORITY_CONFIG.STANDARD;
}

/**
 * Validates if the user can accept a task based on priority and acceptance criteria.
 * Returns null if valid, or an error message string if not.
 */
export function validateAcceptTask(
  task: TaskDetail,
  allUpcomingTasks: TaskDetail[],
  myTasks: TaskDetail[],
  moveLimit: number,
  auditLimit: number
): string | null {
  // Check acceptance criteria
  const myMoveTasks = myTasks.filter((t) => t.TaskType === 'Move').length;
  const myAuditTasks = myTasks.filter((t) => t.TaskType === 'Audit').length;

  if (task.TaskType === 'Move' && myMoveTasks >= moveLimit) {
    return `You can only accept ${String(moveLimit)} Move task(s) at a time.`;
  }
  if (task.TaskType === 'Audit' && myAuditTasks >= auditLimit) {
    return `You can only accept ${String(auditLimit)} Audit task(s) at a time.`;
  }

  // Check priority: warn if accepting standard when critical/high exist
  const taskPriority = getPriorityInfo(task.Priority);
  if (taskPriority.name === 'Standard') {
    const hasCritical = allUpcomingTasks.some(
      (t) => getPriorityInfo(t.Priority).name === 'Critical'
    );
    if (hasCritical) {
      return 'There are Critical priority tasks available. Please consider accepting those first.';
    }
    const hasHigh = allUpcomingTasks.some((t) => getPriorityInfo(t.Priority).name === 'High');
    if (hasHigh) {
      return 'There are High priority tasks available. Please consider accepting those first.';
    }
  }

  return null;
}
